import React from 'react';
import { mint } from '../Assets';

const Mint = () => {
  return (
    <div className="w-full max-w-screen-xl mx-auto px-4 md:px-10 py-20 text-white">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-center">
        <div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold uppercase mb-4">Claim Your<br />Place</h2>
          <p className="text-base sm:text-lg uppercase mb-6">Own a piece of Molundra’s history. Mint your destiny.</p>
          <button className="self-start bg-[#06FF3C] text-black px-6 md:px-10 py-2 text-sm md:text-base rounded-tr-3xl rounded-bl-3xl hover:opacity-80 transition shadow-[0_0_10px_#06FF3C] uppercase font-semibold disabled:cursor-not-allowed"
          disabled
          >
            Coming Soon
          </button>
        </div>
        <div>
          <img src={mint} alt="Mint" className="w-full h-auto sm:h-80 md:h-96 object-cover rounded-md" />
        </div>
      </div>
    </div>
  );
};

export default Mint;